<template>
  <div id="app-card" class="align-middle mx-auto">
    <b-card id="styles">
      <b-list-group flush>
          <div>
             <img src="../assets/ticksuccess.png" alt="">
          </div>
        <div class='stepTitle'><h2>🙌 <b>Felicitaciones</b> 🙌</h2></div>
        <b-list-group-item>
          <strong>Los participantes fueron registrados correctamente
        </b-list-group-item> 
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
const axios = require('axios').default;

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
axios
  .defaults
  .headers
  .post['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS, PUT, PATCH, DELETE';

export default {
  props: [
    'categoria',
    'jugador1',
    'jugador2',
    'jugador3',
    'jugador4',
    'jugador5',
    'jugador6',
    'jugador7',
    'jugador8',
    'jugador9',
    'jugador10',
    'idcapitan',
  ],
  data() {
    return {
      hasErrors: false,
      errors: [],
    };
  },
  async created(){
    var link = document.createElement( "link" );
    link.href = "css/estilos.css";
    link.rel = "stylesheet";
    document.getElementsByTagName( "head" )[0].appendChild( link );
  },
  methods: {
    async confirm(correctData) {
      if (correctData) {
        document.getElementById('Btn-Aceptar').disabled = true;
        // send data to backend
        await axios.post('https://lawn-tennis.wapchita.com/historiales/setGroup/', {
          "id": `${this.idcapitan}`,
          "category": `${this.categoria}`,
          "p1": `${this.jugador1}`,
          "p2": `${this.jugador2}`,
          "p3": `${this.jugador3}`,
          "p4": `${this.jugador4}`,
          "p5": `${this.jugador5}`,
          "p6": `${this.jugador6}`,
          "p7": `${this.jugador7}`,
          "p8": `${this.jugador8}`,
          "p9": `${this.jugador9}`,
          "p10": `${this.jugador10}`
        })
        .then((response) => {
          console.log(response.data);
          
        })
        .catch((error) => {
          console.log(error);
        });
      } else {
        this.$router.push({
          name: 'registro',
          params: {},
        });
      }
    },
  },
};
</script>

<style scoped lang="sass">
  .card-header
    .card-title
      font-family: 'GilroyMedium', sans-serif;
  button
    margin: auto

  #Btn-Aceptar
    color: white;
    border-width: 0;
    border-radius: 5px;
    background-color: #2a4fe3;
    font-family: 'GilroyBold', sans-serif;

  .card-footer
    display: flex
    flex-direction: column

    .button-container
      display: flex
      flex-direction: row
      margin-top: 10px

      button
        flex: 1
        margin: 0 20px

  .bg-color
    background-color: #204BC3 !important

  .volver-bg
    font-family: 'GilroyBold', sans-serif;
    background-color: #f5f5f5 !important
    color: #333333 !important;
    border: none;

  .alignhorizontal
    horizontal-align: middle;

  .list-group-flush>.list-group-item
    border-width: 0px;

  #styles
    border-radius: 0px !important
    border: 0px !important
    box-shadow: none !important

  .sizexl
    height: 100vh !important
</style>